import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  adminDashboardData,
  dashboardData,
} from "../../Api/services/dashboardService";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboard: {
      number_of_active_employees: 0,
      number_of_pending_requests: 0,
      number_of_active_job_positions: 0,
      number_of_completely_filled_job_positions: 0,
      number_of_empty_job_positions_slots: 0,
      employees_by_gender: [],
      employees_by_age: [],
      employees_by_contract_type: [],
    },
    adminDashboard: {
      number_of_active_users: 0,
      number_of_backup_archives: 0,
      number_of_inactive_users: 0,
      number_of_locations: 0,
      number_of_templates: 0,
      number_of_users: 0,
      percentage_of_active_users: 0,
      percentage_of_inactive_users: 0,
    },
    error: null,
    loading: false,
  },
  extraReducers: (builder) => {
    //Dashboard data
    builder
      .addCase(dashboardData.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(dashboardData.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error("Main Dashboard data error");
        }
        return {
          ...state,
          dashboard: action?.payload?.data || {},
          loading: false,
        };
      })
      .addCase(dashboardData.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    // Admin Dashboard data
    builder
      .addCase(adminDashboardData.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(adminDashboardData.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error("Admin Dashboard data error");
        }
        return {
          ...state,
          adminDashboard: action?.payload?.data || {},
          loading: false,
        };
      })
      .addCase(adminDashboardData.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
  },
});

export default dashboardSlice.reducer;
